import { createFileRoute, Outlet } from "@tanstack/react-router";

import { InvoiceGateProvider } from "@/features/invoice-gate/components/invoice-gate-context";

export const Route = createFileRoute("/(app)/dashboard/invoice-gate")({
  component: () => (
    <InvoiceGateProvider>
      <Outlet />
    </InvoiceGateProvider>
  ),
});
